import { render, staticRenderFns } from "./CalendarEventManagement.vue?vue&type=template&id=433651dd&scoped=true&"
import script from "./CalendarEventManagement.vue?vue&type=script&lang=js&"
export * from "./CalendarEventManagement.vue?vue&type=script&lang=js&"
import style0 from "./CalendarEventManagement.vue?vue&type=style&index=0&id=433651dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433651dd",
  null
  
)

export default component.exports